import PageShell from "@/components/PageShell";
import { WHY_CHOOSE, APPROACH } from "@/lib/content";
import { Link } from "react-router-dom";
import { clientLogo } from "@/lib/assets";

// Small trusted-by strip (top-tier known clients from our 21-strong client list)
const TRUSTED_BY = [
  { slug: "turkish-airlines", name: "Turkish Airlines" },
  { slug: "ziraat-bankasi", name: "Ziraat Bankası" },
  { slug: "kpmg", name: "KPMG" },
  { slug: "anka", name: "ANKA" },
  { slug: "cma-cgm", name: "CMA CGM" },
  { slug: "tpao", name: "Türkiye Petrolleri Anonim Ortaklığı" },
];

export default function WhyUs() {
  return (
    <PageShell
      testId="why-us-page"
      title="Why Choose Salihi Group — Nine Reasons"
      description="Integrated services, local knowledge, international outlook, confidentiality, responsive support, long-term relationship approach — nine reasons organisations choose Salihi Group in Somalia."
      eyebrow="Why Us"
      heading={<>Why choose <em className="text-gold not-italic">Salihi Group</em>.</>}
      subheading="Nine reasons organisations trust Salihi Group with important professional work."
      breadcrumbs={[{ label: "Why Us" }]}
    >
      {/* 9 pillars */}
      <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-24">
        {WHY_CHOOSE.map((w, i) => (
          <article
            key={w.title}
            data-testid={`why-card-${i}`}
            className="bg-white border border-softgray p-8 md:p-10 hover:border-gold transition-colors group"
          >
            <div className="flex items-baseline gap-4 mb-5">
              <span className="font-mono text-gold text-sm tabular-nums">
                {(i + 1).toString().padStart(2, "0")}
              </span>
              <span className="gold-hairline flex-1" />
            </div>
            <h2 className="font-serif text-navy text-xl md:text-2xl font-light leading-tight mb-4">{w.title}</h2>
            <p className="text-mutedink text-[15px] leading-relaxed font-light">{w.body}</p>
          </article>
        ))}
      </div>

      {/* Professional approach */}
      <section className="mb-24">
        <div className="max-w-3xl mb-10">
          <div className="flex items-center gap-3 mb-4">
            <span className="gold-hairline" />
            <span className="text-gold text-[11px] uppercase tracking-[0.28em] font-medium">Our Professional Approach</span>
          </div>
          <h2 className="font-serif text-navy text-3xl md:text-4xl font-light">
            The six steps behind every engagement.
          </h2>
        </div>
        <ol className="grid md:grid-cols-2 gap-x-10 gap-y-6 text-navy">
          {APPROACH.map((step, i) => (
            <li key={step} className="flex gap-5 items-start border-b border-softgray pb-6">
              <span className="font-mono text-gold text-sm tabular-nums pt-1">0{i + 1}</span>
              <span className="text-[16px] font-light leading-relaxed">{step}</span>
            </li>
          ))}
        </ol>
      </section>

      {/* Trusted-by strip */}
      <section className="border-t border-softgray pt-16">
        <div className="max-w-3xl mb-8">
          <div className="flex items-center gap-3 mb-4">
            <span className="gold-hairline" />
            <span className="text-gold text-[11px] uppercase tracking-[0.28em] font-medium">Trusted by</span>
          </div>
          <h2 className="font-serif text-navy text-2xl md:text-3xl font-light">
            A selection of organisations who have engaged Salihi Group.
          </h2>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-6 items-center opacity-90">
          {TRUSTED_BY.map((c) => (
            <div key={c.slug} className="h-14 flex items-center justify-center grayscale hover:grayscale-0 transition"
                 data-testid={`why-trusted-${c.slug}`}>
              <img src={clientLogo(c.slug)} alt={c.name}
                   className="max-h-full max-w-full object-contain" loading="lazy" />
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <div className="mt-20 text-center">
        <Link to="/contact" className="btn-gold" data-testid="why-us-cta-contact">Start a conversation</Link>
      </div>
    </PageShell>
  );
}
